export const getHours = () => {
  let hoursArray = []

  for (let hour = 9; hour <= 19; hour++) {
    for (let minute = 0; minute < 2; minute++) {
      let formattedHour = hour < 10 ? `0${hour}` : `${hour}`
      let formattedMinute = minute * 30
      formattedMinute = formattedMinute < 10 ? `0${formattedMinute}` : `${formattedMinute}`
      let value = `${formattedHour}:${formattedMinute}`
      let label = `${formattedHour}:${formattedMinute}`

      hoursArray.push({ value, label })
    }
  }
  hoursArray.pop()
  return hoursArray
}
